
export const isLoggedUser = user => user && user.id && !user.registering; 

export const isAdminUser = user => isLoggedUser(user) && parseInt(user.admin) === 1

export const isMorphedUser = morph => morph && morph.id;

